import { useLang } from "@/lib/i18n";

export default function Marquee() {
  const { t } = useLang();
  const row = [...t.marquee, ...t.marquee, ...t.marquee];
  return (
    <section
      className="relative border-y border-[#2D2520] py-10 overflow-hidden bg-[#110E0C]"
      data-testid="marquee-section"
      aria-hidden="true"
    >
      <div className="marquee-track flex w-max items-center gap-24">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center gap-24">
            {row.map((w, i) => (
              <span key={`${half}-${i}`} className="flex items-center gap-24">
                <span className="font-serif text-3xl md:text-4xl italic text-[#A69C95]/40 whitespace-nowrap">
                  {w}
                </span>
                <span className="h-1.5 w-1.5 rotate-45 bg-[#D48C46]/40" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </section>
  );
}
